export const PVNKZ_AMMOLITE_INCREMENT_RATE = 1 / 43200;
export const BABIEZ_AMMOLITE_INCREMENT_RATE = 1 / 21600;
